window.addEventListener("load", function () {
  var p404 = document.getElementById("p404");
  var appInfo = p404 && p404.querySelector(".app_info");
  if (!appInfo) return;

  // Trượt app_info từ dưới lên mỗi khi header vào viewport
  // (lúc load xong hoặc khi scroll từ frame dưới lên lại header)
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        appInfo.classList.add("is-show");
      } else {
        // gỡ class để lần vào viewport sau chạy lại hiệu ứng
        appInfo.classList.remove("is-show");
      }
    });
  }, { threshold: 0.35 });

  observer.observe(appInfo);
});
